/**
 * Utilitaire pour gérer le comportement des cards mobiles qui remplacent les tableaux
 * sur les appareils mobiles
 */

// Fonction principale
function initializeMobileCards() {
  // Gérer le clic sur les cards
  setupCardNavigation();

  // Optimiser le comportement des éléments de formulaire
  preventCardClickOnFormElements();

  // Gérer les changements d'état des switches
  setupSwitchToggle();
}

// Configurer la navigation lors du clic sur une card
function setupCardNavigation() {
  document.querySelectorAll('.card.cursor-pointer').forEach(card => {
    card.addEventListener('click', function(e) {
      // Ne pas naviguer si on clique sur un élément de formulaire
      if (e.target.closest('input, button, select, textarea, a, .form-check')) {
        return;
      }

      const href = this.getAttribute('data-href');
      if (href) {
        window.location.href = href;
      }
    });
  });
}

// Empêcher la navigation lorsqu'on interagit avec des éléments de formulaire
function preventCardClickOnFormElements() {
  const formElements = document.querySelectorAll('.card.cursor-pointer input, .card.cursor-pointer button, .card.cursor-pointer select, .card.cursor-pointer textarea, .card.cursor-pointer .form-check');

  formElements.forEach(element => {
    element.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
}

// Gérer les changements d'état des switches
function setupSwitchToggle() {
  document.querySelectorAll('.form-check-input.campaign-switch').forEach(checkbox => {
    checkbox.addEventListener('change', function(e) {
      e.stopPropagation();

      const url = this.getAttribute('data-url');
      const frequency = this.getAttribute('data-frequency') || 1;

      if (url) {
        // Ajouter une classe pour indiquer le chargement
        this.closest('.card')?.classList.add('loading');

        // Envoyer la requête AJAX pour mettre à jour l'état
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
          },
          body: JSON.stringify({
            active: this.checked,
            frequency: frequency
          })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          // Traiter la réponse si nécessaire
          this.closest('.card')?.classList.remove('loading');
        })
        .catch(error => {
          console.error('Error:', error);
          this.closest('.card')?.classList.remove('loading');
          // Réinitialiser l'état du switch en cas d'erreur
          this.checked = !this.checked;
        });
      }
    });
  });
}

// Initialiser quand le DOM est chargé
document.addEventListener('DOMContentLoaded', initializeMobileCards);

// Réinitialiser lors des navigations Turbolinks
document.addEventListener('turbolinks:load', initializeMobileCards);
